module.exports = ".customButActive{\n    width:130px;\n    background-color:rgb(31,106,221);\n    margin:15px 0px 15px;\n    color: white\n}\n.customButDisabled{\n    width:130px;\n    background-color:rgb(157,157,157);\n    margin:15px 0px 15px;\n    color: white\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/register/register.component.css
// module id = ./src/app/register/register.component.css
// module chunks = main